import React, { useState } from "react";
import Modal from "../../../../../components/ModalPopup";
import Button from "../../../../../components/Button";
import ButtonList from "../../../../../components/ButtonList";

const RecordViewerModal = (
  isOpen,
  setIsOpen,
  selectedRecord,
  selectedClientId,
) => {
  const record = selectedRecord ? selectedRecord : {};
  const recordId = record?.id ? record.id : "";
  const source = record?.meta?.source ? record.meta.source : "";
  const clientId = selectedClientId ? selectedClientId : "";

  const [copiedSourceRecordId, setCopiedSourceRecordId] = useState(false);
  const [copiedFullRecordId, setCopiedFullRecordId] = useState(false);
  const [copiedJson, setCopiedJson] = useState(false);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === "fullRecordId") {
      setCopiedFullRecordId(true);
      setTimeout(() => setCopiedFullRecordId(false), 1000);
    } else if (type === "json") {
      setCopiedJson(true);
      setTimeout(() => setCopiedJson(false), 1000);
    }
  };

  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)}>
      <div
        style={{
          width: "120vw",
          maxWidth: "1200px",
          maxHeight: "500px",
          overflow: "auto",
          background: "#f5f5f5",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "1rem",
          fontFamily: "monospace",
          fontSize: "0.95rem",
          wordBreak: "break-all",
          position: "relative",
        }}
      >
        <pre style={{ margin: 0 }}>{JSON.stringify(record, null, 2)}</pre>
      </div>
      <div style={{ float: "left", marginRight: "1rem", marginTop: "1rem" }}>
        <Button
          onClick={() =>
            handleCopy(`${clientId}|${source}|${recordId}`, "fullRecordId")
          }
        >
          Copy ClientId|SourceId|RecordId
        </Button>
        {copiedFullRecordId && (
          <span style={{ color: "green", marginLeft: "0.5rem" }}>Copied</span>
        )}
      </div>
      <div style={{ float: "left", marginRight: "1rem", marginTop: "1rem" }}>
        <Button
          onClick={() => handleCopy(JSON.stringify(record, null, 2), "json")}
        >
          Copy Record JSON
        </Button>
        {copiedJson && (
          <span style={{ color: "green", marginLeft: "0.5rem" }}>Copied</span>
        )}
      </div>
      <div style={{ float: "right", marginLeft: "1rem", marginTop: "1rem" }}>
        <Button onClick={() => setIsOpen(false)}>Close</Button>
      </div>
    </Modal>
  );
};

export default RecordViewerModal;
